var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-fluid",style:({
    backgroundImage: `url(${_vm.src})`,
    paddingBottom: '100%',
    width: '100%',
    backgroundSize: 'cover'
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }